export function clickDownloadElement(part: BlobPart[], nomeArquivo: string, atributoId = 'downloadElement') {
    const url = window.URL.createObjectURL(new Blob(part));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', nomeArquivo);
    link.setAttribute('id', atributoId);
    document.body.appendChild(link);
    link.click();
    var element = document.getElementById(atributoId);
    if (element) {
        element.outerHTML = '';
    }
}